import React, { useEffect, useRef, useState } from 'react'
import { ArrayCell } from "../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { HrefCell } from "../framework/forms/helpercomponents/CustomGridCells/HrefCell";
import { TimeCell } from "../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { ImageCell } from "../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { CheckboxCell } from "../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { getSelectedState, Grid, GridColumn } from "@progress/kendo-react-grid";
import EditRoundButton from '../framework/forms/helpercomponents/buttons/EditRoundButton';
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOGEVENT, MEDIA_ATTACHMENT_TYPE, MODULE, TOAST_TYPES } from '../framework/constant/constant';
import { DateOnlyCell, LocalDateTimeColumn } from '../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { LookupCell } from '../framework/forms/helpercomponents/CustomGridCells/LookupCell';
import { getter } from '@progress/kendo-data-query';
import { useTranslation } from '../locale/useTranslation';
import { ContextMenu } from 'primereact/contextmenu';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import MultiVersioningForm from '../modules/MediaLibrary/MultiVersioningForm';
import CollectionSelection from '../framework/forms/CollectionSelection';
import * as API from "../framework/API/api";
import { ConfirmAlert, ConfirmDeleteAlert } from '../ConfirmAlert';
import { EditPageHeader } from './EditPageHeader';
import { TimePickerWithFormat } from '../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../framework/utility/utilityProvider';
import MediaEpisodeHistory from '../modules/Planning/MediaEpisodeHistory';
import { orderBy } from '@progress/kendo-react-data-tools';
import UpdateMultipleEpisodeDialog from './UpdateMultipleEpisodeDialog';
import BossDialog from './BossDialog';
import DeleteRoundButton from '../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { EnumCell } from '../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import AttachMediaCollectionSelection from '../modules/MediaLibrary/attachmentMedia/AttachMediaCollectionSelection';
import ToastNotification from './ToastNotification';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const CardListGridView = (props) => {

    const { data, dataColumns, onEditDataItem, onArchiveEpisodes, enableSelection, setSelectedData, showUpdateMultiple, setShowUpdateMultiple, showEdit = true, showDelete = false, onDeleteDataItem, shortBy = "_id", source = {} } = props;

    const lang = useTranslation();
    const cm = useRef(); //RIGHT CLICK : CONTEXT MENU
    const ref = useRef();

    const [selectedState, setSelectedState] = useState({});
    const [selectedEpisode, setSelectedEpisode] = useState([]);
    const [showFormatsCollection, setShowFormatsCollection] = useState(false);
    const [showUpdateDuration, setShowUpdateDuration] = useState(false);
    const [dataItem, setDataItem] = useState({
        Duration: selectedEpisode[0]?.Duration ? utility.convertMilisecondsToStringWithFrames(selectedEpisode[0]?.Duration) : ""
    });
    const [showHistory, setShowHistory] = useState(false);
    const [showAttachMediaCollection, setShowAttachMediaCollection] = useState(false);

    const initialSort = [{ field: shortBy, dir: "asc" }];
    const [sort, setSort] = useState(initialSort);

    useEffect(() => {
        setSelectedState(props.selectedState);
        setSelectedEpisode(data);
    }, [props.selectedState]);

    useEffect(() => {
        setSort([{ field: shortBy, dir: "asc" }]);
    }, [shortBy]);

    const MyCommandCell = (props) => (
        <td style={props.style} className={props.className} colSpan={props.colSpan} role={"gridcell"}>
            <div style={{ display: "flex", marginTop: '15px' }}>
                {showEdit && <EditRoundButton onClick={() => onEditDataItem(0, props.dataItem)} />}
                {showDelete && <DeleteRoundButton onClick={() => { ConfirmDeleteAlert(() => onDeleteDataItem?.(props.dataItem), () => { }); }} />}
            </div>
        </td>
    )

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={dataColumns} />
    );

    const gridRowRender = (tr, props) => {

        const trProps = {
            onContextMenu: (e) => {
                ref.current = props.dataItem;
                if (Object.keys(selectedState).length == 0 && enableSelection) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
                    return;
                }
                if (enableSelection) {
                    cm.current.show(e);
                }
            },
        };
        return React.cloneElement(tr, { ...trProps }, tr.props.children);
    };

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });

        setSelectedState(newSelectedState);

        //need to get selected
        let selectedItems = data.filter((x) => newSelectedState[x._id]);
        setSelectedEpisode(selectedItems);
        setSelectedData(selectedItems)
    };

    const contextMenuCancel = () => {
        setSelectedEpisode([]);
        setSelectedState({});
        setSelectedData([]);
    };

    const handleFormatDataList = async (dataList) => {

        if (dataList.length > 0) {
            selectedEpisode.forEach((item) => {
                item.Formats = dataList;
            });
            setSelectedEpisode(selectedEpisode);
            setSelectedData(selectedEpisode);
            let media = selectedEpisode.map(x => {
                return {
                    _id: x._id,
                    SID: x.SID,
                    AssetId: x.AssetId,
                    Duration: x.Duration
                }
            })
            let payload = {
                media: media,
                formats: dataList
            }
            let saveFormats = await API.attachFormats(payload);
            console.log(saveFormats);
            if (saveFormats.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.format_attached_success_message });
                // Log capture
                selectedEpisode.forEach((item) => {
                    let logData = { event: LOGEVENT.UPDATE_EPISODE, module: MODULE.EPISODE, data: item, message: saveFormats.message };
                    API.SaveLogs(logData);
                })
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: saveFormats.message });
            }
            contextMenuCancel();
        }
    }

    const deleteAllFormats = async () => {
        for (const element of selectedEpisode) {
            let saveFormats = await API.saveData(ENTITYNAME.MediaEpisode, { _id: element._id, Formats: [] });
            console.log(saveFormats);
            // Log capture
            let logData = { event: LOGEVENT.UPDATE_EPISODE, module: MODULE.EPISODE, data: element, message: saveFormats.message };
            API.SaveLogs(logData);
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.formats_deleted_success_message });
        contextMenuCancel();
    }

    const handleDurationSave = async () => {
        if (!dataItem.Duration || dataItem.Duration == "" || dataItem.Duration == "00:00:00:00" || dataItem.Duration.includes('_') || utility.convertStringWithFramesToMilliseconds(dataItem.Duration) == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_duration_error_message });
            return;
        }
        let media = selectedEpisode.map(x => {
            return {
                ...x,
                Duration: utility.convertStringWithFramesToMilliseconds(dataItem.Duration) ?? 0
            }
        });
        let res = await API.saveData(ENTITYNAME.MediaEpisode, media);
        if (res.success) {
            // Log capture
            media.forEach((item) => {
                let logData = { event: LOGEVENT.UPDATE_EPISODE, module: MODULE.EPISODE, data: item, message: res.message };
                API.SaveLogs(logData);
            })
            // update duration in grid
            media.forEach((item) => {
                let index = data.findIndex(x => x._id == item._id);
                data[index].Duration = item.Duration;
            })
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.duration_updated_success_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setShowUpdateDuration(false);
        contextMenuCancel();
    }
    const historyRef = useRef();
    const setHistoryRef = (data) => {
        historyRef.current = data
    }

    const history = (item) => {
        console.log('history');
        console.log(item[0])
        setHistoryRef(item);
        setShowHistory(true);
    };

    const multipleUpdateFormClose = () => {
        setShowUpdateMultiple(false);
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const onExportXML = async (data) => {

        console.log("ASSET XML EXPORT");

        if (data.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }

        let mediaData = data.map((item) => {
            return {
                _id: item._id,
            }
        })

        let res = await API.getXMLExportV2(mediaData);
        if (res.success) {

            if (res.data.length > 1) {
                let payload = {
                    fileNames: res.data,
                    folderName: data[0].Title
                }

                console.log(payload)
                await API.downloadZip(payload);
            } else {
                window.open(FILEURL().BASEURL + 'downloadReport/' + res.data[0])
            }
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${res.data.length} asset files exported & delivered successfully!` });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

        contextMenuCancel();

    }

    const onExportSegmentation = async (data) => {

        let payload = [];

        data?.map((x) => {
            payload.push({ _id: x._id, mediaCategorySID: x?.MediaCategory?.SID });
        })

        let res = await API.getSegmentationDataExport(payload);
        if (res.success) {
            if (res.dataLength == 0) {
                ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_for_selected_filter_error_message });
                return;
            }
            else {
                window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Successfully Exported!' });
            }
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const handleAttachedMediaSelect = async (dataList = []) => {

        if (selectedEpisode?.length == 0) {
            ToastNotification({ message: lang.no_data_found_error_message });
            return;
        }

        let newAttachedMedia = [];
        if (ENTITYNAME.Season === source?.entityName) {
            for (const selectedItem of selectedEpisode) {
                for (const item of dataList) {
                    const isLong = item?.MediaCategory?.isLong || item?.MediaEpisode?.MediaCategory?.isLong;
                    let attachedMediaDataEntity = {
                        attachedMedia: {
                            _id: item?._id,
                            SID: item?.SID,
                            Title: isLong ? item?.MediaEpisode?.Title : item?.Title,
                            AssetId: isLong ? item?.MediaEpisode?.AssetId : item?.AssetId,
                            MediaCategory: isLong ? item?.MediaEpisode?.MediaCategory : item?.MediaCategory,
                            Type: isLong ? MEDIA_ATTACHMENT_TYPE.SEGMENT : MEDIA_ATTACHMENT_TYPE.MEDIAEPISODE
                        },
                        srcId: source?._id,
                        srcType: ENTITYNAME.Season,
                        mediaEpisodeId: selectedItem?._id
                    }
                    newAttachedMedia.push(attachedMediaDataEntity);
                }
            }
        }

        let res = await API.createAndUpdateAttachMedias(newAttachedMedia);
        if (!res.success) {
            ToastNotification({ message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_attached_success_message });
        }
        contextMenuCancel();
    }

    const onRemoveAttachedMedias = async () => {
        let res = await API.deleteAttachedMedias({ query: [["srcId", "=", source?._id,], ["mediaEpisodeId", "in", selectedEpisode?.map((x) => x?._id)]] });
        if (!res.success) {
            ToastNotification({ message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        }
        contextMenuCancel();
    }

    return (
        <div style={{ padding: '5px' }}>
            <ExcelExport data={data} ref={props._export}>
                <Grid
                    style={{
                        height: 'calc(100vh - 240px)',
                        width: '35vw',
                        scrollbarWidth: "none"
                    }}
                    data={orderBy(data.map((item) => ({
                        ...item,
                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                    })), sort)}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    rowRender={gridRowRender}
                    resizable={true}
                    onColumnResize={handleColumnResize}
                    sortable={true}
                    sort={sort}
                    onSortChange={(e) => {
                        setSort(e.sort);
                    }}
                    selectable={{
                        enabled: props.enableSelection ?? false,
                        cell: false,
                        mode: "multiple",
                    }}
                    onSelectionChange={onSelectionChange}
                >
                    <GridColumn cell={MyCommandCell} width={(showEdit && showDelete) ? "90px" : "60px"} locked={true} />
                    {/* Rows Loop */}
                    {dataColumns.map((column, index) => {
                        if (column.type === COLUMNSTYPE.date) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={DateOnlyCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    sortable={true}
                                />
                            );
                            // }else if (column.name === COLUMNSTYPE.time) {
                        }
                        else if (column.name.includes("enum") || column.type == COLUMNSTYPE.enum) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={EnumCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    sortable={true}
                                />
                            );
                        } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={TimeCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    sortable={true}
                                />
                            );
                        } else if (column.name === "SID") {
                            return;
                            //we are not returning any value for SID column
                        } else if (column.type === COLUMNSTYPE.image) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={ImageCell}
                                    title={column.label}
                                    width={100}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.select) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={MyDatalookupCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.checkbox) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={CheckboxCell}
                                    title={column.label}
                                    width={80}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.array) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={ArrayCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    format={column.format ?? "Description"} //display item in object
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.href) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={HrefCell}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    format={column.format}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.localdatetime) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={LocalDateTimeColumn}
                                    title={column.label}
                                    width={200}
                                    format={column.format}
                                    sortable={true}
                                />
                            );
                        }
                        else {
                            return (
                                column.type !== COLUMNSTYPE.hidden && (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                )
                            );
                        }
                    })}
                </Grid>
            </ExcelExport>

            <ContextMenu
                ref={cm}
                model={[
                    {
                        label: 'Update multiple',
                        icon: "pi pi-fw pi-pencil",
                        command: () => {
                            if (selectedEpisode.length == 0) {
                                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select atleast one item" });
                                return;
                            }
                            setShowUpdateMultiple(true);
                        },
                    },
                    {
                        label: lang.ref_attach_formats_label,
                        icon: "pi pi-fw pi-paperclip",
                        command: () => {
                            setShowFormatsCollection(true);
                        },
                    },
                    {
                        label: lang.update_slot_duration_label,
                        icon: "pi pi-fw pi-pen-to-square",
                        command: () => {
                            setShowUpdateDuration(() => true);
                        },
                    },
                    {
                        label: lang.ref_attach_media_label,
                        icon: "pi pi-fw pi-paperclip",
                        items: [
                            {
                                label: lang.attach_label,
                                icon: "pi pi-fw pi-paperclip",
                                command: () => {
                                    setShowAttachMediaCollection(true);
                                },
                            },
                            {
                                label: lang.delete_label,
                                icon: "pi pi-fw pi-trash",
                                command: () => {
                                    ConfirmDeleteAlert(() => onRemoveAttachedMedias(), () => { });
                                },
                            },
                        ]
                    },
                    {
                        label: lang.show_history_button_text,
                        icon: "pi pi-fw pi-history",
                        command: () => {
                            history(selectedEpisode);
                        },
                    },
                    {
                        label: lang.export_label,
                        icon: 'pi pi-fw pi-file-excel',
                        items: [
                            {
                                label: lang.ref_export_xml_label,
                                icon: 'pi pi-fw pi-file-excel',
                                command: () => {
                                    onExportXML(selectedEpisode);
                                },
                            },
                            {
                                label: lang.ref_export_segment_label,
                                icon: 'pi pi-fw pi-file-excel',
                                command: () => {
                                    onExportSegmentation(selectedEpisode);
                                },
                            },
                        ]
                    },
                    {
                        label: !props.archiveEpisode ? lang.archive : lang.un_archive_label,
                        icon: "pi pi-fw pi-window-minimize",
                        command: () => {
                            onArchiveEpisodes(selectedEpisode, props.archiveEpisode);
                            contextMenuCancel();
                        },
                    },
                    {
                        label: lang.ref_delete_formats_label,
                        icon: "pi pi-fw pi-trash",
                        command: () => {
                            ConfirmDeleteAlert(() => deleteAllFormats(), () => { });
                        },
                    },
                    {
                        label: lang.ref_cancel_label,
                        icon: "pi pi-fw pi-times",
                        command: () => {
                            contextMenuCancel();
                        },
                    }

                ]}
            />

            {props.showMultiVersionPopup && <MultiVersioningForm selectedData={selectedEpisode} closeForm={() => { props.setShowMutliVersionPopup(false); contextMenuCancel(); }} />}
            {showFormatsCollection && <CollectionSelection title={lang.select_format_collection} entityname={ENTITYNAME.Format} setDataList={handleFormatDataList} closeForm={() => setShowFormatsCollection(false)} mode={'single'} width={"50vw"} />}
            {showUpdateDuration && <BossDialog title={lang.update_slot_duration_label} onClose={() => setShowUpdateDuration(false)} width={400} height={200}>
                <EditPageHeader title={""} onSubmit={handleDurationSave} onCancel={() => setShowUpdateDuration(false)} showTitle={false} />
                <div className='mt-2'>
                    <label htmlFor="">{lang.duration_label} *</label>
                    <TimePickerWithFormat
                        className="form-control form-control-sm"
                        name="Duration"
                        value={dataItem.Duration}
                        onChange={(e) => setDataItem({ ...dataItem, Duration: e.target.value })}
                    />
                </div>
            </BossDialog>}
            {showHistory && <MediaEpisodeHistory selectedData={historyRef.current} closeForm={() => setShowHistory(false)} />}
            {showUpdateMultiple && <UpdateMultipleEpisodeDialog refresh={props.loadEpisodes} selectedEpisode={selectedEpisode} setSelectedEpisode={setSelectedEpisode} closeForm={multipleUpdateFormClose} />}
            {showAttachMediaCollection && <AttachMediaCollectionSelection hideSeriesSeason={true} addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} setDataList={handleAttachedMediaSelect} closeForm={() => setShowAttachMediaCollection(false)} width={"50vw"} />}
        </div>
    )
}

export default CardListGridView